<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-items-end tw-mb-4">
      <button
        @click="navigateToCreateOrder"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('orders.titles.new') }}
      </button>
    </div>
    <OrdersFancyTable :customerId="selectedCustomerId" :isDashboard="false" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import OrdersFancyTable from './Table/OrdersFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import router from '@/router';
import { useCustomerStore } from '@/stores/customer.store';

import { useI18n } from 'vue-i18n';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

const navigateToCreateOrder = () => {
  router.push({ name: 'create-order' });
};

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'orders.titles.orders',
    },
  ]);
});
</script>
